import { LibraryUsageItem } from '../types/library-usage'
import { buildLibraryUsageItemID } from './library-usage-data'

const fileNames = [
  'System.Func<T,U>',
  'System.Generics.ICollections.IterIntoDictionary<T,U>',
  '/lib/arel/visitors/mssql.rb',
  '/lib/arel/attributes/arel/attributes/arel/attributes/arel/attributes/arel/attributes/arel/attributes/arel/attributes/arel/attributes/arel/attributes/arel/attributes/arel/attributes/attribute.rb',
  '/lib/arel/insert_manager.rb',
  '/lib/arel/nodes/case.rb',
  '/lib/arel/nodes/update_statement.rb',
  '/lib/arel/nodes/join_source.rb',
  '/lib/arel/visitors/informix.rb',
  '/lib/arel/update_manager.rb',
  '/lib/arel/nodes/false.rb',
  '/lib/arel/nodes/bind_param.rb',
  '/lib/arel/math.rb',
  '/lib/arel/nodes/full_outer_join.rb',
  '/lib/arel.rb',
  '/lib/fog/ibm/core.rb',
  '/lib/fog/linode/dns.rb',
  '/lib/fog/cloudsigma/compute.rb',
  '/lib/fog/bare_metal_cloud/core.rb',
  '/lib/fog/openvz/compute.rb',
  '/lib/fog/dreamhost/core.rb',
  '/lib/fog/fogdocker/core.rb',
  '/lib/fog/fogdocker/errors.rb',
  '/lib/fog/dreamhost.rb',
  '/lib/fog/ibm/compute.rb',
  '/lib/fog/fogdocker.rb',
  '/lib/fog/vcloud.rb',
  '/lib/fog/dnsmadeeasy/core.rb',
  '/lib/fog/rage4/core.rb',
  '/lib/fog/vcloud/compute.rb',
  '/lib/fog/openvz.rb',
  '/lib/fog/vcloud_director/core.rb',
  '/lib/fog/bare_metal_cloud/compute.rb',
  '/lib/fog/dnsmadeeasy.rb',
  '/lib/fog/linode.rb',
  '/lib/fog/clodo.rb'
]

export function getMockLibraryUsageItems(
  applicationID,
  libraryHash
): LibraryUsageItem[] {
  const date = new Date()
  const dateString = date.toISOString()

  return fileNames.map((name) => ({
    id: buildLibraryUsageItemID({
      applicationID,
      libraryHash,
      name
    }),
    name,
    firstSeen: dateString,
    lastSeen: dateString
  }))
}
